import { render, staticRenderFns } from "./SubscriptionInactiveGate.vue?vue&type=template&id=25e84456"
import script from "./SubscriptionInactiveGate.vue?vue&type=script&lang=js"
export * from "./SubscriptionInactiveGate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports